import { render, staticRenderFns } from "./OrderChangeCommon.vue?vue&type=template&id=a27413b6&scoped=true"
import script from "./OrderChangeCommon.vue?vue&type=script&lang=js"
export * from "./OrderChangeCommon.vue?vue&type=script&lang=js"
import style0 from "./OrderChangeCommon.vue?vue&type=style&index=0&id=a27413b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27413b6",
  null
  
)

export default component.exports